import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ModalController } from '@ionic/angular';
import { MaskitoOptions } from '@maskito/core';
import { select, Store } from '@ngrx/store';

import { SeriesOption } from 'echarts';
import { cloneDeep, filter as lodashFilter, map } from 'lodash-es';
import { Observable, tap } from 'rxjs';
import { filter } from 'rxjs/operators';

import { calculatorChartOptions } from '../../../../constants/calculator-chart-options.constants';
import { rateMask } from '../../../../constants/maskito.constants';
import * as fromCalculatorActions from '../../../../store/actions/calculator.actions';
import * as fromCalculatorSelectors from '../../../../store/selectors/calculator.selectors';
import { AmortizationReportData } from '../../../../typings/calculator';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-amortization-report-modal',
  standalone: false,
  templateUrl: './report-modal.component.html'
})
export class ReportModalComponent {
  private modalController = inject(ModalController);
  private store = inject(Store);

  selectData$: Observable<AmortizationReportData | null>;
  reportData: AmortizationReportData | undefined;

  readonly rateMask: MaskitoOptions = rateMask;

  chartOptions = cloneDeep(calculatorChartOptions);

  constructor() {
    this.selectData$ = this.store.pipe(
      select(fromCalculatorSelectors.selectAmortizationReportData),
      filter((data) => !!data),
      tap((data) => {
        this.handleChartData(data);
        this.reportData = data;
      })
    );
  }

  close() {
    return this.modalController.dismiss(null, 'cancel');
  }

  async save() {
    if (this.reportData) {
      this.store.dispatch(
        fromCalculatorActions.saveAmortizationReport({
          payload: {
            reportData: this.reportData
          }
        })
      );
    }

    await this.close();
  }

  private handleChartData(data: AmortizationReportData) {
    (this.chartOptions.series as SeriesOption[])[0].data = lodashFilter(
      map(
        [
          {
            label: 'Principal',
            value: data.principalPercentage
          },
          {
            label: 'Interest',
            value: data.interestPercentage
          }
        ],
        (item) => {
          return {
            name: item.label,
            value: item.value
          };
        }
      ),
      (item) => item.value > 0
    );
  }
}
